const SHARE = 'share';
const SCHEDULE = 'schedule';

export { SHARE, SCHEDULE };
